import { render, staticRenderFns } from "./SegmentListCreateOrEdit.vue?vue&type=template&id=b6e6ee58&"
import script from "./SegmentListCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./SegmentListCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports